<template>
	<div class="steps" :class="customClass">
		<div class="step" v-for="(step, index) in steps" :key="index">
			<div class="anchor"></div>
			<div class="line" v-if="index !== 0"></div>
			<div class="text">
				{{ step }}
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['steps', 'active', 'customClass'],
		
		data() {
			return {
				
			};
		}
	}
</script>

<style lang="scss" scoped>
	.ZIJIN {
		.anchor {
			background: url(~@/assets/img/icon_step.png) no-repeat;
		}
	}
	.steps {
		padding-left: 33px;
		display: flex;
		justify-content: space-around;
		align-items: center;
		
		.step {
			flex: 1;
			text-align: center;
			
			.anchor {
				margin: 3px auto 0;
				width: 8px;
				height: 8px;
				border-radius: 8px;
				background: url(~@/assets/img/icon_step.png) no-repeat;
				background-size: 8px 8px;
				background-position: center center;
			}

			.line {
				position: relative;
				margin-left:10%;
				right: 50%;
				top: -4px;
				height: 0.5px;
				width: 80%;
				background: #D5CEF3;
			}

			.text {
				padding-top: 5px;
			}
		}
		
	}
</style>
